/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const SubPageTemplateListDocument = gql`
    query SubPageTemplateList($field: String, $order: String) {
  subPageTemplateList(field: $field, order: $order) {
    id
    name
    page {
      id
      type
      title
      image
    }
    position
  }
}
    `;

/**
 * __useSubPageTemplateListQuery__
 *
 * To run a query within a React component, call `useSubPageTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubPageTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubPageTemplateListQuery({
 *   variables: {
 *      field: // value for 'field'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSubPageTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>(SubPageTemplateListDocument, options);
      }
export function useSubPageTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>(SubPageTemplateListDocument, options);
        }
// @ts-ignore
export function useSubPageTemplateListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>): Apollo.UseSuspenseQueryResult<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>;
export function useSubPageTemplateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>): Apollo.UseSuspenseQueryResult<SubPageTemplateListQuery | undefined, SubPageTemplateListQueryVariables>;
export function useSubPageTemplateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>(SubPageTemplateListDocument, options);
        }
export type SubPageTemplateListQueryHookResult = ReturnType<typeof useSubPageTemplateListQuery>;
export type SubPageTemplateListLazyQueryHookResult = ReturnType<typeof useSubPageTemplateListLazyQuery>;
export type SubPageTemplateListSuspenseQueryHookResult = ReturnType<typeof useSubPageTemplateListSuspenseQuery>;
export type SubPageTemplateListQueryResult = Apollo.QueryResult<SubPageTemplateListQuery, SubPageTemplateListQueryVariables>;
export const CreateTemplateSubPageDocument = gql`
    mutation CreateTemplateSubPage($pageId: Int!, $name: String!, $position: Int) {
  createTemplateSubPage(pageId: $pageId, name: $name, position: $position) {
    id
    name
    page {
      id
    }
    position
  }
}
    `;
export type CreateTemplateSubPageMutationFn = Apollo.MutationFunction<CreateTemplateSubPageMutation, CreateTemplateSubPageMutationVariables>;

/**
 * __useCreateTemplateSubPageMutation__
 *
 * To run a mutation, you first call `useCreateTemplateSubPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateSubPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateSubPageMutation, { data, loading, error }] = useCreateTemplateSubPageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      name: // value for 'name'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useCreateTemplateSubPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateSubPageMutation, CreateTemplateSubPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateSubPageMutation, CreateTemplateSubPageMutationVariables>(CreateTemplateSubPageDocument, options);
      }
export type CreateTemplateSubPageMutationHookResult = ReturnType<typeof useCreateTemplateSubPageMutation>;
export type CreateTemplateSubPageMutationResult = Apollo.MutationResult<CreateTemplateSubPageMutation>;
export type CreateTemplateSubPageMutationOptions = Apollo.BaseMutationOptions<CreateTemplateSubPageMutation, CreateTemplateSubPageMutationVariables>;
export const UpdateTemplateSubPageDocument = gql`
    mutation UpdateTemplateSubPage($id: Int!, $pageId: Int!, $name: String, $position: Int) {
  updateTemplateSubPage(
    id: $id
    pageId: $pageId
    name: $name
    position: $position
  ) {
    id
    name
    page {
      id
    }
    position
  }
}
    `;
export type UpdateTemplateSubPageMutationFn = Apollo.MutationFunction<UpdateTemplateSubPageMutation, UpdateTemplateSubPageMutationVariables>;

/**
 * __useUpdateTemplateSubPageMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateSubPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateSubPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateSubPageMutation, { data, loading, error }] = useUpdateTemplateSubPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *      name: // value for 'name'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useUpdateTemplateSubPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateSubPageMutation, UpdateTemplateSubPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateSubPageMutation, UpdateTemplateSubPageMutationVariables>(UpdateTemplateSubPageDocument, options);
      }
export type UpdateTemplateSubPageMutationHookResult = ReturnType<typeof useUpdateTemplateSubPageMutation>;
export type UpdateTemplateSubPageMutationResult = Apollo.MutationResult<UpdateTemplateSubPageMutation>;
export type UpdateTemplateSubPageMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateSubPageMutation, UpdateTemplateSubPageMutationVariables>;
export const DeleteTemplateSubPageDocument = gql`
    mutation DeleteTemplateSubPage($id: Int!) {
  deleteTemplateSubPage(id: $id)
}
    `;
export type DeleteTemplateSubPageMutationFn = Apollo.MutationFunction<DeleteTemplateSubPageMutation, DeleteTemplateSubPageMutationVariables>;

/**
 * __useDeleteTemplateSubPageMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateSubPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateSubPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateSubPageMutation, { data, loading, error }] = useDeleteTemplateSubPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateSubPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateSubPageMutation, DeleteTemplateSubPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateSubPageMutation, DeleteTemplateSubPageMutationVariables>(DeleteTemplateSubPageDocument, options);
      }
export type DeleteTemplateSubPageMutationHookResult = ReturnType<typeof useDeleteTemplateSubPageMutation>;
export type DeleteTemplateSubPageMutationResult = Apollo.MutationResult<DeleteTemplateSubPageMutation>;
export type DeleteTemplateSubPageMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateSubPageMutation, DeleteTemplateSubPageMutationVariables>;
export type SubPageTemplateListQueryVariables = Types.Exact<{
  field?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SubPageTemplateListQuery = { __typename?: 'Query', subPageTemplateList: Array<{ __typename?: 'GraphTemplateSubPage', id?: number | null, name?: string | null, position?: number | null, page?: { __typename?: 'GraphPage', id?: number | null, type?: number | null, title?: string | null, image?: string | null } | null }> };

export type CreateTemplateSubPageMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
  name: Types.Scalars['String']['input'];
  position?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CreateTemplateSubPageMutation = { __typename?: 'Mutation', createTemplateSubPage: { __typename?: 'GraphTemplateSubPage', id?: number | null, name?: string | null, position?: number | null, page?: { __typename?: 'GraphPage', id?: number | null } | null } };

export type UpdateTemplateSubPageMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  pageId: Types.Scalars['Int']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  position?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateTemplateSubPageMutation = { __typename?: 'Mutation', updateTemplateSubPage: { __typename?: 'GraphTemplateSubPage', id?: number | null, name?: string | null, position?: number | null, page?: { __typename?: 'GraphPage', id?: number | null } | null } };

export type DeleteTemplateSubPageMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteTemplateSubPageMutation = { __typename?: 'Mutation', deleteTemplateSubPage: boolean };
